export default __webpack_public_path__ + "static/media/Heart@1x.8aa00646.png";